<template>
  <div class="modalTable">
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button type="primary" @click="funcFilter()">查询</el-button>
        <el-button type="primary" @click="getSelectEvent">确定</el-button>
      </template>
    </vxe-toolbar>

    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      height="80%"
      :loading="loading"
      :checkbox-config="{ highlight: true }"
      :data="tableData"
      align="center"
      auto-resize
      @checkbox-change="checkboxChangeEvent"
      @checkbox-all="selectAll"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="name" title="实际承运人姓名" min-width="130" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="实际承运人手机号"
          min-width="150"
        >
          <template #default="{ row }">
            {{ maskPhone(row.phone) }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="实际承运人手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseNumber"
          title="车牌号"
          min-width="130"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicenseNumber"
            placeholder="车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLoadStatusName"
          title="负载状态"
          min-width="130"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleLoadStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <!-- <vxe-table-column>
        <vxe-table-column field="linkMan" title="车队名称" min-width="130" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.linkMan"
            placeholder="车队名称"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="vehicleOutsideDimensions"
          title="外廓尺寸(mm)"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleOutsideDimensions"
            placeholder="外廓尺寸"
            clearable
            disabled
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLoadWeightName"
          title="载重"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLoadWeightName"
            placeholder="载重"
            clearable
            disabled
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleClassificationName"
          title="车型"
          min-width="150"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleClassificationCode"
            placeholder="请选择车辆类型"
            clearable
            filterable
          >
            <el-option
              v-for="item in vehicleClassificationList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { tedDriver } from "@/api/orderform";
import { getListDict } from "@/api/commonApi";
export default {
  name: "Child",
  props: {
    branchCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tooltipVisible: false,
      loading: false,
      tableData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        // driverType: "3",
        driverType: "6",
        name: "",
        phone: "",
        headImg: "",
        linkMan: "",
        vehicleLicenseNumber: "",
        vehicleLength: "",
        vehicleClassification: "",
        vehicleLoadStatus: "",
        isFreeze: "0",
        authStatus: "3",
        workStatus: "1",
        authStatusExt: "3",
        branchCodeExt: ""
      },
      selectArrs: [],
      Pagingconf: [],
      selectRecords: [],
      vehicleClassificationList: [],
      options: [
        {
          value: "0",
          label: "空载"
        },
        {
          value: "1",
          label: "负载"
        }
      ]
    };
  },
  watch: {
    branchCode() {
      this.designcar();
    }
  },
  created() {
    getListDict({
      types: "vehicleClassification"
    }).then(response => {
      this.vehicleClassificationList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
    });
    this.designcar();
    this.$nextTick(() => {
      let show = localStorage.getItem("tooltipVisible") || false;
      if (!show) {
        this.tooltipVisible = true;
      } else {
        this.tooltipVisible = false;
      }
    });
  },
  methods: {
    addDriver() {
      this.tooltipVisible = false;
      localStorage.setItem("tooltipVisible", true);
    },
    checkboxChangeEvent(event) {
      // console.log("checkboxChangeEvent", event);
    },
    selectAll(event) {
      this.selectArrs = event.records;
    },
    closes() {
      this.listQuery = {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        driverType: "3",
        name: "",
        phone: "",
        headImg: "",
        linkMan: "",
        vehicleLicenseNumber: "",
        vehicleLength: "",
        vehicleClassification: "",
        vehicleLoadStatus: "",
        isFreeze: "0",
        authStatus: "3",
        workStatus: "1",
        authStatusExt: "3",
        branchCodeExt: ""
      };
      // console.log("1111111111", this.selectArrs);
      this.selectArrs = [];
    },
    designcar(params) {
      if (this.branchCode) {
        this.listQuery.branchCodeExt = this.branchCode;
      }
      this.findList();
    },
    findList() {
      this.loading = true;
      // this.listQuery.isMasterBind = "1";
      tedDriver(this.listQuery).then(response => {
        this.loading = false;
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
      });
    },
    // 电话号码脱敏方法
    maskPhone(phone) {
      if (!phone) return "";
      const phoneStr = phone.toString();
      if (phoneStr.length === 11) {
        // 11位手机号：显示前3位和后4位，中间4位用*替换
        return phoneStr.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      } else if (phoneStr.length >= 7) {
        // 其他长度的电话号码：保留前3位和后4位，中间用*替换
        const start = phoneStr.substring(0, 3);
        const end = phoneStr.substring(phoneStr.length - 4);
        const middle = "*".repeat(phoneStr.length - 7);
        return start + middle + end;
      }
      return phoneStr; // 长度不足7位的直接返回原值
    },
    getSelectEvent() {
      let selectRecords = this.$refs.xTable.getSelectRecords();
      console.log("selectRecords", selectRecords);
      if (selectRecords.length > 0) {
        this.$emit("event", selectRecords, 0);
      } else {
        this.$message({ message: "请至少选择一个实际承运人", type: "warning" });
      }
    }
  }
};
</script>

<style></style>
